import { Api } from '../../Api';
import { IServiceEdocsParams, IServiceEDoc } from '@shared/api';

export class Edocs {
    private static _basePath = '/Edocs';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Edocs._basePath}`;
        return {
            async generate({ accountNumber, types, beginDate, endDate }: IServiceEdocsParams) {
                const path = `/generate`;
                return await Api.post<IServiceEDoc[]>({
                    path: `${basePath}${path}`,
                    body: { accountNumber, types, beginDate, endDate },
                });
            },
        };
    }
}
